import React from 'react';
import { useSelector } from 'react-redux';
import ItemPeopleOffer from './ItemPeopleOffer';

const ItemCloseNoWinner = () => {
  const { offers } = useSelector((state) => state.detail.detail);
  return (
    <div className="bg-alabaster p-3 pt-5">
      <h3 className="text-tangaroa text-left">
        Subasta cerrada
      </h3>

      <hr />
      <div className={offers.length > 8 ? 'max-offer' : ''}>
        <h3 className="text-left mt-30">Ofertas realizadas</h3>
        {offers.map((o) => (
          <ItemPeopleOffer
            offer={o.offer}
            person={o.personName}
            type="Closed" />
        ))}
      </div>
    </div>
  );
};

export default ItemCloseNoWinner;
